// utils/getLocalIP.js
export const getLocalIP = () => {
  return new Promise((resolve) => {
    const ips = new Set();
    const pc = new RTCPeerConnection({ iceServers: [{ urls: "stun:stun.l.google.com:19302" }] });

    pc.createDataChannel("");
    pc.createOffer().then((offer) => pc.setLocalDescription(offer));

    pc.onicecandidate = (event) => {
      if (!event.candidate) {
        pc.close();
        // Cerca l'IP pubblico (srflx) — quello che vede il server STUN
        const publicIP =
          [...ips].find((ip) => !ip.startsWith("192.168.") && !ip.startsWith("10.") && !ip.startsWith("172.")) ||
          null;

        console.log("🌐 Tutti gli IP trovati:", [...ips]);
        console.log("🌍 IP pubblico rilevato:", publicIP);
        resolve(publicIP);
        return;
      }

      const { candidate } = event.candidate;
      const match = candidate.match(/(\d{1,3}(?:\.\d{1,3}){3})/);
      if (match) ips.add(match[1]);
    };

    setTimeout(() => { pc.close(); resolve(null); }, 4000);
  });
};